import { registerActions } from "../actionRegistry";
import { toastSuccess } from "../ui/messages";
import { api } from "../api";
import { fadeOut } from "../utils/dom";

export async function reupload(id: string, action: string): Promise<void> {
  try {
    await api.reupload.handle({
      id: Number(id),
      action: action as "approve" | "approveqc" | "reject",
    });
    fadeOut(`reupload-${id}`);
    toastSuccess("Re-upload handled");
  } catch (err: unknown) {
    alert((err as Error).message);
  }
}

registerActions({
  reupload,
});
